import { Link } from 'wouter';
import { liveIndustries } from '@/marketing/live';
import { useTranslation } from 'react-i18next';
import { LanguageSelector } from '@/components/LanguageSelector';
import { ScopieLogo } from '@/components/brand/ScopieLogo';
import { SignupForm } from './SignupForm';
import { useHomeAuth } from './useHomeAuth';

/** `home` is false on every other marketing page: the anchors then point at the landing (`/#features`) and the logo goes home. */
export function HomeNav({ home = true }: { home?: boolean } = {}) {
  const at = home ? '' : '/';
  const { t } = useTranslation('home');
  const { isAuthenticated, dashboardPath } = useHomeAuth();

  return (
    <nav className="hn" aria-label={t('landing.nav.main')}>
      <div className="wrap">
        <a className="logo" href={home ? '#top' : '/'} aria-label={t('landing.nav.home')}>
          <ScopieLogo />
        </a>
        <div className="links">
          <a href={`${at}#features`}>{t('landing.nav.features')}</a>
          <a href={`${at}#pricing`}>{t('landing.nav.pricing')}</a>
          <a href={`${at}#who`}>{t('landing.nav.who')}</a>
          {liveIndustries().length > 0 && <Link href="/for">{t('landing.nav.industries')}</Link>}
        </div>
        <div className="navr">
          <div className="lang">
            <LanguageSelector />
          </div>
          {isAuthenticated ? (
            <Link href={dashboardPath} className="btn btn-y btn-sm">
              {t('landing.nav.dashboard')}
            </Link>
          ) : (
            <>
              <Link href="/login" className="login">
                {t('landing.nav.login')}
              </Link>
              <SignupForm compact />
            </>
          )}
        </div>
      </div>
    </nav>
  );
}
